module.exports = __webpack_public_path__ + "media/images/logo_jcb-132c7f80206533fa60ffa452502ea5e8.png";